
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"44","height":"44","x":"5.303","y":"5.521","fill":"#D0EFEC","rx":"22"}}),_c('circle',{attrs:{"cx":"20.069","cy":"19.953","r":"7.196","stroke":"#234652","transform":"rotate(18.765 20.07 19.953)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"m40.138 14.785-25.67 25.12"}}),_c('circle',{attrs:{"cx":"34.538","cy":"34.737","r":"7.196","stroke":"#234652","transform":"rotate(18.765 34.538 34.737)"}})])
          )
        }
      }
    